




























































































import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import FileagentWidget from "./widgets/fileagent/fileAgentWidget.vue";
import ChatWidget from "./widgets/chat/ChatWidget.vue";
import JitsiWidget from "./widgets/jitsi/JitsiWidget.vue";
import RadioButtonWidget from "./widgets/radioButton/RadioButtonWidget.vue";
import DrawWidget from "./widgets/draw/DrawWidget.vue";
import PlyrWidget from "./widgets/plyr/PlyrWidget.vue";
import CloudflareplayerWidget from "./widgets/cloudflareplayer/CloudflareplayerWidget.vue";
import MarkdownWidget from "./widgets/markdown/MarkdownWidget.vue";
import { WidgetConfiguration } from "../interfaces/widgetConfiguration";
import { WidgetState } from "../interfaces/widgetState";
import { WidgetPayload } from "../interfaces/widgetPayload";
import { Layout } from "../interfaces/layout";

@Component
export default class Toolbox extends Vue {
    @Emit() public click(event: { type: string; static: boolean }) {
        return event;
    }

    @Emit() public reuse(event: { widgetId: string }) {
        return event;
    }

    @Prop() public configurations!: WidgetConfiguration<
        WidgetState,
        WidgetPayload
    >[];

    @Prop() public pages?: {
        fullscreenWidgetId: string | null;
        layout: Layout[];
        configurationIds: string[];
    }[];
    @Prop() public pageIndex?: number;

    public hasPermission(item: {
        permissionRequired: string;
        permissionExclude: string | null;
    }) {
        if (
            this.$store.state.user.permissions.includes(item.permissionExclude)
        ) {
            return false;
        } else if (
            this.$store.state.user.permissions.includes(item.permissionRequired)
        ) {
            return true;
        }
    }

    public get notAssignedConfigurations() {
        if (!this.pages || this.pageIndex == null) {
            return [];
        }
        if (this.pages.length <= this.pageIndex) {
            return [];
        }
        return this.configurations.filter(
            c =>
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !this.pages![this.pageIndex!]?.configurationIds.includes(
                    c.widgetId
                )
        );
    }

    public widgetDisabled(item: {
        name: string;
        component: {
            type: string;
            static: boolean;
        };
    }) {
        if (item.component.static) {
            if (this.configurations.find(t => t.type === item.component.type)) {
                return true;
            }
        }
        if (
            item.component.type === "jitsi" &&
            this.participants >= this.maxParticipants
        ) {
            return true;
        }
    }

    public get participants(): number {
        return this.$store.state.studio?.attributes?.participants || 0;
    }
    public get maxParticipants(): number {
        return 20;
    }
    public get warningActive(): boolean {
        if (
            this.participants / this.maxParticipants >= 0.75 &&
            this.participants / this.maxParticipants < 1
        ) {
            return true;
        } else {
            return false;
        }
    }
    public itemHeight(item: {
        name: string;
        component: {
            type: string;
            static: boolean;
        };
    }): number {
        if (this.widgetDisabled(item)) {
            return 50;
        } else if (this.warningActive && item.component.type === "jitsi") {
            return 80;
        } else return 105;
    }
    public get items() {
        return [
            {
                name: "Chat",
                component: ChatWidget,
                permissionRequired: "presenter",
                permissionExclude: null,
            },
            {
                name: "Video Conference",
                component: JitsiWidget,
                permissionRequired: "presenter",
                permissionExclude: null,
            },
            {
                name: "Survey",
                component: RadioButtonWidget,
                permissionRequired: "presenter",
                permissionExclude: null,
            },
            {
                name: "Whiteboard",
                component: DrawWidget,
                permissionRequired: "presenter",
                permissionExclude: null,
            },
            {
                name: "File Agent",
                component: FileagentWidget,
                permissionRequired: "presenter",
                permissionExclude: null,
            },
            {
                name: "Media Player",
                component: PlyrWidget,
                permissionRequired: "presenter",
                permissionExclude: "cloudflare",
            },
            {
                name: "Text Editor",
                component: MarkdownWidget,
                permissionRequired: "presenter",
                permissionExclude: null,
            },
            {
                name: "Media Player (Premium)",
                component: CloudflareplayerWidget,
                permissionRequired: "cloudflare",
                permissionExclude: null,
                css: "gradient-border",
            },
        ];
    }
}
